module.exports = __webpack_public_path__ + "img/owl.580e648c.svg";